(function () {
  function isAllLoaded(container) {
    const pm = container.closest('page-manager');

    // pager mode: no "load all", so don't hide OOS
    if (pm && pm.getAttribute('data-pagination-mode') === 'pager') return true;

    // If load-more button is missing OR hidden OR disabled => fully loaded
    const btn =
      pm?.querySelector('pagination-load-more .btn-load-more') ||
      document.querySelector('pagination-load-more .btn-load-more');

    if (!btn) return true;

    const isHidden =
      btn.style.display === 'none' ||
      btn.hidden ||
      btn.closest('[hidden]') ||
      btn.closest('.hide') ||
      btn.offsetParent === null;

    const isDisabled = btn.disabled || btn.getAttribute('disabled') === 'true';

    return isHidden || isDisabled;
  }

  function reorderAndToggle(container) {
    const productItems = Array.from(container.querySelectorAll('.product-item'));
    if (!productItems.length) return;

    const allLoaded = isAllLoaded(container);

    // Save original order once
    productItems.forEach((item, idx) => {
      if (!item.dataset.originalOrder) item.dataset.originalOrder = String(idx + 1);
    });

    const inStock = [];
    const oos = [];

    for (const item of productItems) {
      const card = item.querySelector('[data-product-card]');
      if (!card) continue;

      const orig = parseInt(item.dataset.originalOrder, 10) || 0;
      const available = card.dataset.available === 'true';

      (available ? inStock : oos).push({ el: item, orig });
    }

    inStock.sort((a, b) => a.orig - b.orig);
    oos.sort((a, b) => a.orig - b.orig);

    // Always show in-stock first
    let order = 1;
    for (const x of inStock) {
      x.el.style.display = '';
      x.el.style.order = order++;
    }

    // Hide OOS until the very end; then show + move to bottom
    if (!allLoaded) {
      for (const x of oos) x.el.style.display = 'none';
    } else {
      for (const x of oos) {
        x.el.style.display = '';
        x.el.style.order = order++;
      }
    }
  }

  function run(scope) {
    (scope || document)
      .querySelectorAll('[data-product-grid]')
      .forEach(reorderAndToggle);
  }

  function init() {
    run(document);

    // Re-run after CB page-manager loads more items
    document.querySelectorAll('page-manager').forEach(pm => {
      pm.addEventListener('pageLoaded', () => run(document));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Throttled DOM observer (so it doesn't spam)
  let t;
  const mo = new MutationObserver(() => {
    clearTimeout(t);
    t = setTimeout(() => run(document), 50);
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();